import { render } from "./KeyValueTable.vue?vue&type=template&id=c99b74d8&scoped=true"
import script from "./KeyValueTable.vue?vue&type=script&lang=js"
export * from "./KeyValueTable.vue?vue&type=script&lang=js"

import "./KeyValueTable.vue?vue&type=style&index=0&id=c99b74d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99b74d8"]])

export default __exports__